// src/pages/DonatePage.js

import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // <-- Import Link for routing

function DonatePage() {
  return (
    <>
      {/* ------------------------------------------
          Inline Style to Force Montserrat Globally
          (Remove if using a global CSS file)
      ------------------------------------------- */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');
          
          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link, label {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== DONATE PAGE HERO BANNER ========== */}
      <div
        style={{
          backgroundColor: '#c8102e',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>
            Support Our Mission
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            Your generosity helps us fund vital BFS research, community outreach, and patient support initiatives.
          </p>
        </Container>
      </div>

      {/* ========== DONATION OPTIONS SECTION ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="mb-4 text-center">
            <Col>
              <h2 style={{ fontWeight: '700', fontSize: '2rem' }}>Ways to Donate</h2>
              <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0.5rem auto' }}>
                From online contributions to mail-in checks—find the method that suits you best.
              </p>
            </Col>
          </Row>
          <Row>
            {[
              {
                title: 'Online Donation',
                text: 'Donate securely with a credit card or PayPal. Your contribution goes directly to BFS support programs.',
                icon: 'https://cdn-icons-png.flaticon.com/512/1029/1029183.png',
                link: '/contact' // <-- All "Learn More" => /contact
              },
              {
                title: 'Recurring Monthly Gift',
                text: 'Provide ongoing support for BFS awareness by setting up a recurring gift that fits your budget.',
                icon: 'https://cdn-icons-png.flaticon.com/128/3081/3081648.png',
                link: '/contact'
              },
              {
                title: 'Donate by Mail',
                text: 'Prefer to write a check? Send it to our official mailing address and we’ll handle the rest.',
                icon: 'https://cdn-icons-png.flaticon.com/512/3243/3243166.png',
                link: '/contact'
              },
            ].map((option, idx) => (
              <Col md={4} className="mb-4" key={idx}>
                <Card className="h-100 shadow-sm text-center">
                  <Card.Body>
                    <img
                      src={option.icon}
                      alt={`${option.title} icon`}
                      style={{ width: '60px', marginBottom: '1rem' }}
                    />
                    <Card.Title className="fw-semibold">{option.title}</Card.Title>
                    <Card.Text>{option.text}</Card.Text>
                    {/* Button linking to contact page */}
                    <Button variant="danger" as={Link} to={option.link}>
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* ========== IMAGE LEFT / "YOUR CONTRIBUTION MATTERS" RIGHT ========== */}
      <div style={{ padding: '4rem 0' }}>
        <Container>
          <Row className="align-items-center">
            {/* Left: Image with Red Border */}
            <Col md={6} className="mb-4 mb-md-0">
              <img
                src="https://images.pexels.com/photos/3184437/pexels-photo-3184437.jpeg"
                alt="Volunteers or BFS representation"
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  border: '6px solid #c8102e' // BFS red border
                }}
              />
            </Col>

            {/* Right: "Your Contribution Matters" Text */}
            <Col md={6}>
              <h2 style={{ fontWeight: '700', marginBottom: '1rem', fontSize: '1.8rem' }}>
                Your Contribution Matters
              </h2>
              <p style={{ fontSize: '1.1rem' }}>
                Every dollar you donate helps us provide valuable resources for individuals living with
                Benign Fasciculation Syndrome. From educational materials to community forums, your generosity
                ensures that those affected by BFS can find the support and answers they need.
              </p>
              <p style={{ fontSize: '1.1rem' }}>
                Thank you for partnering with us to raise awareness, fund research, and empower people around
                the globe to live better with BFS. Together, we can make a real difference.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default DonatePage;
